import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const PricesPage = () => {
  const navigate = useNavigate();
  const [showNotifyForm, setShowNotifyForm] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleFreeClick = () => {
    navigate('/auth');
  };

  const handleProClick = () => {
    setShowNotifyForm(true);
  };

  const handleNotifySubmit = (e) => {
    e.preventDefault();
    console.log('Notifying email:', email);
    setSubmitted(true);
    setTimeout(() => {
      setShowNotifyForm(false);
      setSubmitted(false);
      setEmail('');
    }, 3000);
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#A89B8D]">
      <Header />
      
      <main className="flex-grow py-8 px-4 sm:px-8 lg:px-8">
        {/* Hero Section - Matching Products Page style */}
        <div className="mb-10 w-full rounded-3xl bg-gradient-to-r from-[#E9A969] to-[#EDEAF4] shadow-xl overflow-hidden">
          <div className="flex flex-col justify-center items-center text-center px-10 py-14">
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#5F40A1] drop-shadow-sm mb-6">
              Subscription Plans
            </h1>
            <p className="text-gray-700 text-lg md:text-xl leading-relaxed max-w-2xl">
              Choose the perfect tier for your skincare journey. From personal recommendations 
              to advanced API access, we have a plan for everyone.
            </p>
          </div>
        </div>

        {/* Pricing Cards Container */}
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Free Tier */}
          <div className="flex flex-col bg-[#EDEAF4] border border-gray-200 rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300">
            <h2 className="text-xl font-bold text-[#5F40A1] mb-2 text-center">Free Tier</h2>
            <div className="flex flex-col items-center mb-4">
              <span className="text-gray-500 line-through text-base">$5/month</span>
              <span className="text-3xl font-extrabold text-[#5F40A1]">Free</span>
            </div>
            <ul className="text-gray-700 mb-6 flex-grow space-y-3 text-sm">
              <li className="flex items-start">
                <svg className="w-4 h-4 text-[#E9A969] mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Personal recommendations based on Skin Passport and preferences</span>
              </li>
            </ul>
            <button 
              onClick={handleFreeClick}
              className="mt-auto block w-full text-center px-6 py-2.5 rounded-full bg-[#5F40A1] text-white font-bold text-base transition-all hover:bg-[#4A2F82] shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
            >
              Get Started
            </button>
          </div>

          {/* Pro Tier */}
          <div className="flex flex-col bg-white border-2 border-[#E9A969] rounded-3xl p-6 shadow-lg scale-100 md:scale-105 transform transition-all duration-300 relative z-10">
            <div className="absolute -top-3.5 left-1/2 transform -translate-x-1/2 bg-[#5F40A1] text-white text-[10px] font-bold px-4 py-1 rounded-full tracking-wider">
              MOST POPULAR
            </div>
            <h2 className="text-xl font-bold text-[#5F40A1] mb-2 text-center">Pro Tier</h2>
            <div className="flex flex-col items-center mb-4">
              <span className="text-base text-gray-500 mb-0.5">Standard</span>
              <span className="text-3xl font-extrabold text-[#5F40A1]">$10<span className="text-lg font-medium">/mo</span></span>
            </div>
            <ul className="text-gray-700 mb-6 flex-grow space-y-3 text-sm">
              <li className="flex items-start">
                <svg className="w-4 h-4 text-[#E9A969] mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Personal recommendations based on Skin Passport and preferences</span>
              </li>
              <li className="flex items-start">
                <svg className="w-4 h-4 text-[#E9A969] mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>API requests to database (100/day)</span>
              </li>
            </ul>

            {showNotifyForm ? (
              <div className="mt-auto">
                {submitted ? (
                  <p className="text-green-600 font-bold text-center py-2 text-sm">Thank you! We'll notify you soon.</p>
                ) : (
                  <form onSubmit={handleNotifySubmit} className="space-y-2">
                    <p className="text-[11px] text-[#5F40A1] text-center font-medium bg-[#E9A969]/20 py-1.5 rounded-lg">Coming Soon! Leave your email.</p>
                    <input 
                      type="email" 
                      placeholder="Enter your email" 
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-2 rounded-full bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-[#5F40A1] focus:border-transparent"
                    />
                    <button 
                      type="submit"
                      className="block w-full text-center px-6 py-2 rounded-full bg-[#E9A969] text-white font-bold text-sm hover:bg-[#d69e5b] transition-all shadow-md transform hover:-translate-y-0.5"
                    >
                      Notify Me
                    </button>
                    <button 
                      type="button"
                      onClick={() => setShowNotifyForm(false)}
                      className="block w-full text-center text-[10px] text-gray-500 hover:text-[#5F40A1] mt-1 underline"
                    >
                      Close
                    </button>
                  </form>
                )}
              </div>
            ) : (
              <button 
                onClick={handleProClick}
                className="mt-auto block w-full text-center px-6 py-2.5 rounded-full bg-gradient-to-r from-[#7A5CCF] to-[#5F40A1] text-white font-bold text-base transition-all hover:bg-[#4A2F82] shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              >
                Sign Up
              </button>
            )}
          </div>

          {/* Enterprise Tier */}
          <div className="flex flex-col bg-[#EDEAF4] border border-gray-200 rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300">
            <h2 className="text-xl font-bold text-[#5F40A1] mb-2 text-center">Enterprise</h2>
            <div className="flex flex-col items-center mb-4">
              <span className="text-base text-gray-500 mb-0.5">Business Access</span>
              <span className="text-2xl font-extrabold text-[#5F40A1]">Custom Pricing</span>
            </div>
            <ul className="text-gray-700 mb-6 flex-grow space-y-3 text-sm">
              <li className="flex items-start">
                <svg className="w-4 h-4 text-[#E9A969] mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Custom access to API</span>
              </li>
              <li className="flex items-start">
                <svg className="w-4 h-4 text-[#E9A969] mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Dedicated support</span>
              </li>
              <li className="flex items-start">
                <svg className="w-4 h-4 text-[#E9A969] mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Scalable infrastructure</span>
              </li>
            </ul>
            <button 
              onClick={() => navigate('/for-business')}
              className="mt-auto block w-full text-center px-6 py-2.5 rounded-full bg-transparent border-2 border-[#5F40A1] text-[#5F40A1] font-bold text-base transition-all hover:bg-[#5F40A1] hover:text-white shadow-sm transform hover:-translate-y-0.5"
            >
              Contact Us
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PricesPage;